module.exports = __webpack_public_path__ + "img/transition-3.dcaef0e8.png";